import React, { useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TYPES = ['void', 'reissue', 'name_change', 'split_pnr', 'schedule_change', 'other'];

export default function ManualAmendmentPanel({ bookingId, onRecorded }) {
  const [type, setType] = useState('other');
  const [supplierRef, setSupplierRef] = useState('');
  const [fee, setFee] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!bookingId) return;
    setBusy(true);
    try {
      const r = await fetch(`${API}/admin/flights/bookings/${encodeURIComponent(bookingId)}/manual-amendment`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amendment_type: type,
          supplier_ref: supplierRef,
          fee_paid: parseFloat(fee) || 0,
          note,
        }),
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.detail || 'Failed');
      setNote('');
      onRecorded?.(j);
      alert(j.message || 'Recorded');
    } catch (err) {
      alert(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="bg-amber-50 border border-amber-200 rounded-xl p-4 space-y-3" data-testid="manual-amendment-panel">
      <p className="text-[10px] uppercase font-bold text-amber-900">Record manual supplier-portal work</p>
      <p className="text-xs text-amber-800">Ops completes change in Tripjack/Riya portal, then records it here for audit.</p>
      <select value={type} onChange={(e) => setType(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 text-sm">
        {TYPES.map((t) => <option key={t} value={t}>{t.replace(/_/g, ' ')}</option>)}
      </select>
      <input placeholder="Supplier reference" value={supplierRef} onChange={(e) => setSupplierRef(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 text-sm" />
      <input placeholder="Fee paid (₹)" type="number" value={fee} onChange={(e) => setFee(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 text-sm" />
      <textarea placeholder="Notes / checklist" value={note} onChange={(e) => setNote(e.target.value)} rows={2} className="w-full border rounded-lg px-2 py-1.5 text-sm" />
      <button type="submit" disabled={busy} className="px-4 py-2 bg-amber-700 text-white text-sm font-semibold rounded-lg disabled:opacity-50">
        {busy ? 'Saving…' : 'Record manual amendment'}
      </button>
    </form>
  );
}
